<template>
  <div class="mt-3">
    <b-overlay center :show="isLoading" rounded="sm">
      <div class="d-flex" v-if="!isLoading">
        <b-button
          class="btn--transparent justify-content-start ml-3"
          href="https://wichee.emessage.it/CustomDefaultPage/WICHEE/eMessage%20Mio_it.html"
          target="_blank"
        >Vai al pannello di eMessage
          <base-icon name="arrow_ext" width="20" height="20" />
        </b-button
        >
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import BaseIcon from "@/components/BaseIcon";

export default {
  components: {BaseIcon},
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "agency_setup",
      id: this.$store.state.auth.settings.id,
      form: {
        agency_setup: {
          attribute_EMUSR_value: null,
          attribute_EMPWD_value: null,
        },
      },
    };
  },
  methods: {},
  created() {
    this.isLoading = false;
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
<style lang="scss" scoped></style>
